// extracted by mini-css-extract-plugin
module.exports = {"item":"FilterPills_item__6JGyT"};